<template>
  <div class="header">
    <div class="row">
      <a href="/home">
        <img
          :src="require('@/assets/logo.png')"
          class="logo"
          alt=""
        >
      </a>
      <ul class="nav clearfix">
        <li v-for="(item, index) in navlist" v-bind:key="item.id" :class="{on: index === navindex}">
          <a target="_blank" :href="item.url">{{item.tit}}</a>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      navlist: [
        {
          tit: '首页',
          url: '/home.html'
        },
        {
          tit: '纠纷调解',
          url: ''
        },
        {
          tit: '法律咨询',
          url: 'https://testonekb-retrieval.odrcloud.cn'
        },
        {
          tit: '服务资源',
          url: ''
        },
        {
          tit: '帮助中心',
          url: ''
        }
      ]
    }
  },
  props: ['navindex']
}
</script>
<style lang="scss" scoped>
.header {
  height: 85px;
  line-height: 85px;
  // background-color: $head-nav;
  .row {
    height: 85px;
  }
  .logo {
    display: block;
    position: absolute;
    left: 0;
    top: 16px;
    height: 50px;
  }
  .nav {
    /*float: right;*/
    position: absolute;
    right: 0;
    li {
      float: left;
      margin-left: 50px;
      text-align: center;
      a {
        color: #333;
        font-size: 16px;
        font-weight: 600;
      }
      &.on {
        a {
          color: #0083c8;
        }
      }
    }
  }
}
</style>
